export const LineSeparator = () => {
  return (
    <hr
      style={{
        width: "100px",
        color: "#f7b500",
        border: 0,
        borderTop: "1px solid",
        opacity: "90%",
      }}
    />
  );
};
